import { BorderRadiusPropertyEnum, ComponentNameEnum } from '@/types';

const getAllBorderRadiusFieldConfig = (property = 'border-radius', defaultValue = 0) => ({
  componentName: ComponentNameEnum.SPACES,
  options: {
    property,
    [BorderRadiusPropertyEnum.TOP_LEFT]: {
      defaultValue,
      title: 'templateBuilder.fields.radiusTopLeft',
    },
    [BorderRadiusPropertyEnum.TOP_RIGHT]: {
      defaultValue,
      title: 'templateBuilder.fields.radiusTopRight',
    },
    [BorderRadiusPropertyEnum.BOTTOM_LEFT]: {
      defaultValue,
      title: 'templateBuilder.fields.radiusBottomLeft',
    },
    [BorderRadiusPropertyEnum.BOTTOM_RIGHT]: {
      defaultValue,
      title: 'templateBuilder.fields.radiusBottomRight',
    },
  },
});

export default getAllBorderRadiusFieldConfig;
